// Images
import { useState } from 'react';
import logo from '../images/bankist-white.png';
// Icons
import { AiOutlineDashboard } from "react-icons/ai";
import { CiCreditCard1 } from "react-icons/ci";
import { IoReceiptOutline } from "react-icons/io5";
import { MdManageHistory } from "react-icons/md";
import { MdMenu } from "react-icons/md";
// import { Link } from 'react-router-dom';

export default function Sidebar({ setOpenSidebar, openSidebar, setLoggedUser, setIsLoggedIn }) {
    return (
        <div className={`sider-menu ${!openSidebar && "sider-open"}`}>
            <MdMenu className="nav-icon" size={30} onClick={() => setOpenSidebar((item) => !item)} />
            <img src={logo} alt='Logo' className='logo' />
            <ul>
                <li><AiOutlineDashboard size={25} />Dashboard</li>
                <li><CiCreditCard1 size={25} /> About Bankist</li>
                <li><CiCreditCard1 size={25} /> Transactions</li>
                <li><IoReceiptOutline size={25} /> Users</li>
                <li onClick={() => (setLoggedUser(), setIsLoggedIn(false))} className='nav'><MdManageHistory size={25} /> Logout</li>
            </ul>
        </div >
    )
}
